import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';
import $ from 'jquery';

import indigo from '@material-ui/core/colors/indigo';
import { withStyles } from '@material-ui/core/styles';

import withAuthentication from './auth/withAuthentication';

import MenuAppBar from './MenuAppBar';
import MenuAppDrawer from './admin/MenuAppDrawer';

import SignUpPage from './auth/SignUp';
import SignInPage from './auth/SignIn';
import PasswordForgetPage from './auth/PasswordForget';
import AccountPage from './Account';
import GettingStartedPage from './admin/GettingStarted';
import InvoicingPage from './admin/Invoicing';
import BidsPage from './admin/BidsPage';
import WebsitePage from './admin/WebsitePage';
import Preview from './admin/Preview';
import { Unsupported } from './Illustration'
import {
  ClientsPage,
  InvoicesPage,
  ReceiptsPage,
  TimecardsPage,
  JobsPage,
  SetupPage
} from './admin';

import * as routes from '../constants/routes';

const styles = theme => ({
  root: {
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
    display: "flex",
  },
  admin: {
    display: 'flex',
    flexDirection: 'row',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  '@media print': {
    root: {
      display: 'none',
    }
  },
})

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minWidth: 800,
      currentWidth: $(window).width(),
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    const { currentWidth } = this.state;
    const resizeWidth = $(window).width();
    console.log("resizeWidth:", resizeWidth);
    if (currentWidth !== resizeWidth) {
      this.setState({ currentWidth: resizeWidth });
    }
  }

  render() {
    const { authUser, classes, preview } = this.props;
    const { minWidth, currentWidth } = this.state;

    if (currentWidth < minWidth) {
      return (
        <div className={classes.root}>
          <Unsupported />
        </div>
      )
    } else {
      if (authUser) {
        return(
            <Router>
              <Switch>
                <Route exact path="/" render={() => (
                  authUser ? (
                    <Redirect to="/admin/start" />
                  ) : (
                    <Landing />
                  )
                )}/>
                <Route path="/admin" render={(props) => <Admin classes={classes} preview={preview} />}/>
                <Route exact path={routes.SIGN_IN} component={SignInPage} />
                <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
                <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
              </Switch>
            </Router>
        );
      } else {
        return (
          <Router>
            <Switch>
              <Route path={routes.SIGN_IN} component={() => <SignInPage />} />
              <Route path={routes.SIGN_UP} component={() => <SignUpPage />} />
              <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
              <Route component={() => <SignInPage />} />
            </Switch>
          </Router>
        );
      }
    }
  }
}

const Admin = ({ classes, preview }) => {
  return(
    <div className={classes.root}>
      <Preview />
      <MenuAppDrawer>
        <Route exact path={routes.BIDS} component={() => <BidsPage />} />
        <Route exact path={routes.START} component={() => <GettingStartedPage />} />
        <Route exact path={routes.INVOICES} component={InvoicesPage}/>
        <Route exact path={routes.WEBSITE} component={() => <WebsitePage />} />
        <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
        <Route exact path={routes.RECEIPTS} component={ReceiptsPage} />
        <Route exact path={routes.TIMECARDS} component={TimecardsPage} />
        <Route exact path={routes.JOBS} component={JobsPage} />
        <Route exact path={routes.CLIENTS} component={ClientsPage} />
        <Route exact path={routes.SETUP} component={SetupPage} />
      </MenuAppDrawer>
    </div>

  );
};

const Landing = () => {
  return(
    <div>
      <MenuAppBar />
      <div>Landing Page</div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser,
  preview: state.previewState,
});

export default compose(
  withAuthentication,
  withStyles(styles),
  connect(mapStateToProps)
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js